import { Injectable, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from './base.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CommonMessage } from '../models/commonMessage';
import { User } from '../models/user';
import { BehaviorSubject } from 'rxjs';
import { WalletSummaryModel } from '../models/walletSummaryModel';
@Injectable({
  providedIn: 'root'
})
export class SettingService {
  @Output() languageEvent = new EventEmitter();

  private dataValue = new BehaviorSubject<string>(null);

  private categoryName = new BehaviorSubject('default message');
  currentcategory = this.categoryName.asObservable();
  private AcceptTerms = new BehaviorSubject(false);
  currentAcceptTerms = this.AcceptTerms.asObservable();
  private Summary = new BehaviorSubject(new WalletSummaryModel());
  walletSummary = this.Summary.asObservable();
  isError = false;
  message = '';
  lang = 'ar';
  pageName='home';
  showLogOut: boolean;
  public loading: boolean;
  public user: User;
  constructor(private translate: TranslateService) {
    this.lang = localStorage.lang || 'ar';
    this.useLanguage(this.lang);

    if (localStorage.getItem('token')) {
      this.getUserInfoFromToken(localStorage.token);
    }
  }
  useLanguage(language: string) {
    this.lang = language;
    localStorage.lang = language;
    document.dir = language === 'ar' ? 'rtl' : 'ltr';
    this.translate.use(language);
    this.languageEvent.emit('');
  }
  getUserInfoFromToken(token: string) {
    const jwtHelper = new JwtHelperService();
    const data = jwtHelper.decodeToken(token) as User;
    this.user = data;
    this.setLocalStorageValue("mobileNumber",this.user.msisdn)
  }
  showErrorPopup() {
    document.getElementById('errorMessage').click();
  }
  changeCategory(category: string) {
    this.categoryName.next(category)
  }
  setAcceptTerms(accept: boolean) {
    this.AcceptTerms.next(accept);
  }
  setWalletSummary(summary: WalletSummaryModel) {
    this.Summary.next(summary);
  }

  getValueObservable() {
    return this.dataValue.asObservable();
  }

  setLocalStorageValue(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
    this.dataValue.next(value);
  }
}
